import UpdateDriver from "../../../../components/@users/drivers/UpdateDriver";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function DriverUpdatePage() {

    return (
        <UpdateDriver 
            routeType={routeTypes.admin}
        />
    )
}       